controllers.controller('WithdrawLocalWireTransferController', [
    '$scope', '$state', '$stateParams', '$ionicLoading', '$ionicModal', 'LocaleService', 'API', 'ErrorService', 'constants',
    'Validator', 'Storage', 'Utils', 'UserService', 'CountryService',
    function ($scope, $state, $stateParams, $ionicLoading, $ionicModal, LocaleService, API, ErrorService, Const,
              Validator, Storage, Utils, UserService, CountryService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.user = UserService.get();
        $scope.validator = Validator.getPattern;
        $scope.countries = CountryService.get();
        $scope.constants = Const;
        $scope.withdraw = { login: $stateParams.login, amount: $stateParams.amount };
        $scope.modal = { actionText: LocaleService.translation.try_again, state: false };
        $scope.withdrawalReasonsTypes = Storage.get('withdrawalReasons')
            .map(function (reason) {
                return {id: reason, label: $scope.translation.withdrawalReason[reason]};
            });
        $scope.localBanks = Storage.get('localBanks')
            .map(function (bank, index) {
                return {id: index, label: bank}
            });
        $scope.reasonModel = {};
        $scope.reasonModel.selectedReason =  null //$scope.withdrawalReasonsTypes.slice(0, 1).pop();
        $scope.predefinedCountryObject = _.find($scope.countries, {code: $scope.user.country})
        $scope.countryName = $scope.predefinedCountryObject.country;

        console.log({
            test: $scope
        })

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'WithdrawLocalWireTransferController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.isOtherReason = function() {
            return $scope.reasonModel.selectedReason ?
                $scope.reasonModel.selectedReason.id === 'otherReason' : false; };

        $scope.submit = function (form) {
            Utils.formRevalidate(form);
            if (!form.$valid) return;

            var request = {
                login: parseInt($scope.withdraw.login, 10),
                amount: parseInt($scope.withdraw.amount, 10),
                bankName: $scope.withdraw.bankName.label,
                bankAccountHolder: $scope.withdraw.accountHolder,
                bankAccountNumber: $scope.withdraw.bankNumber,
                bankCountry: $scope.predefinedCountryObject.code,
                bankCity: $scope.withdraw.bankCity || '',
                bankState: $scope.withdraw.bankState || '',
                bankAddress: $scope.withdraw.bankStreet,
                comment: $scope.withdraw.comment,
                reason: $scope.reasonModel.selectedReason.id || '',
                reasonComment: $scope.reasonModel.reasonDescription || ''
            };
            $ionicLoading.show();
            return API.withdrawalLocalWireTransfer(request)
                .then(checkResponse)
                .then(function (response) {
                    $ionicLoading.hide();

                    if(Const.withdrawalComplianceRequired && $scope.user.complianceStatus !== 'approved') {
                        return $state.go('root.app.withdrawCompliance');
                    }

                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.textContent = '';
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                    $scope.modal.back = 'root.app.withdraw';
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawalFailed;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || '';
                    $scope.modal.state = true;
                });
        };

        $scope.$on('$ionicView.afterView', function (event) {
            console.log($scope);
        });
        $scope.$on('$ionicView.afterLeave', function (event) {
            $scope.countryModal && $scope.countryModal.hide() && $scope.countryModal.remove();
        });
    }]);
